import {OverlayType2} from "./OverlayType2";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {ParentOverlayCollectionInterface} from "./ParentOverlayCollectionInterface";
import {ChildOverlayCollectionInterface} from "./ChildOverlayCollectionInterface";
import {HttpServiceService} from "../httpService/http-service.service";

export class OverlayType2Collection {
  /**
   * List of all overlays indexed by their ids for faster search.
   */
  protected overlays:Map<number,OverlayType2> = new Map();

  constructor(
    protected view:CesiumAdapterService,
    private httpService: HttpServiceService
  ) {}

  get length() { return this.overlays.size; }

  public add(overlayConfig:OverlayType2|Object) {
    let overlay = this.createOverlay(overlayConfig);
    this.overlays.set(overlay.getId(), overlay);
  }

  public createOverlay(overlayConfig:OverlayType2|Object):OverlayType2 {
    if (!(overlayConfig instanceof OverlayType2)) {
      return new OverlayType2(overlayConfig, this.view, this.httpService);
    } else {
      return overlayConfig;
    }
  }

  public getById(id:number) {
    return this.overlays.get(id);
  }

  public drawAll() {
    this.overlays.forEach((overlay) => {
      overlay.draw();
    });
  }

  public asArray():OverlayType2[] {
    let r = [];
    this.overlays.forEach((item) => { r.push(item); });
    return r;
  }

  public forEach(cb) { this.overlays.forEach(cb); }
}


